import React from 'react';

import {
  Modal,
  PreviewContent,
  ModalCloseButton,
} from 'pages/company/WorkspaceRoute/components/webtwain/components/ImagePopup/StyledComponents';
import Box from '@mui/material/Box';

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

const ImagePopup = ({ image, close }) => (
  <Modal open onClose={close}>
    <PreviewContent>
      <ModalCloseButton onClick={close}>
        <CloseOutlinedIcon />
      </ModalCloseButton>
      <Box boxShadow={10}>
        <img src={image.originalSizeSrc} alt={image.originalSource} style={{ maxHeight: '70vh' }} />
      </Box>
    </PreviewContent>
  </Modal>
);

export default ImagePopup;
